import axios from "axios";
import { message } from "antd";
import { apiHeaders } from "../helper/apiHeader";
import { getStudentData, setLocalStorage } from "../helper/localStorage";

export const fetchTestApi = (
  test_id,
  gradeId,
  dispatchLaunchTest,
  dispatchHelper
) => {
  const myData = {
    data: {
      player_id: getStudentData().login_id,
      grade_id: gradeId,
      test_id,
    },
  };

  dispatchLaunchTest({
    type: "LOADER",
  });

  // const apiHead =
  //   // this test_id id of text matching
  //   test_id === "190425225004" ? "launchtestallque" : "launchtest";

  axios
    .post("/MetaData", myData, apiHeaders("launchtest"))
    .then((res) => {
      if (res.data.status === "201") {
        dispatchLaunchTest({ type: "RUNNING_TEST_DATA", payload: res.data });
        console.log(
          "%claunchtest!",
          "color:red;font-family:system-ui;font-size:2rem;font-weight:bold",
          res.data
        );
        const isCustomId = res.data.data[0].test_format === "tap_letter";
        const FNMix = res.data.data[0].test_format === "visual_facename_mix";

        // const isFNMid = res.data.data[0].test_format === "visual_facename_mix";
        const getTestId = () => {
          return isCustomId
            ? 1
            : FNMix
            ? "11862" // first id for FNMix test
            : res.data.data[0].que[0].id; // custom id for CPT test
        };
        dispatchHelper({
          type: "RUNNING_QUES_ID",
          payload: getTestId(),
        });
        setLocalStorage("RESERVE_TEST_DATA", res.data);
        // dispatchLaunchTest({ type: "RESERVE_TEST_DATA", payload: res.data });
        dispatchLaunchTest({ type: "RESERVE_TEST_ID", payload: getTestId() });
      } else {
        message.error(res.data.msg);
        dispatchLaunchTest({
          type: "ERR",
        });
      }
    })
    .catch((err) => {
      message.error("Please wait for sometime or check your internet connection. Try again!");
      dispatchLaunchTest({
        type: "ERR",
      });
    });
};
